
const dzsHelpers = require('../../inc/js/common/_esjquery.js');
const $es = dzsHelpers.$es;
export const addDocumentationInPluginsPage = () => {

    var _tr = document.querySelector('tr[data-slug="dzs-portal-for-zoomsounds"]');

    var $tr = $es(_tr);
    // console.log(_tr, $tr);
    $tr.find('.deactivate').parent().prepend('<span class="deactivate"><a href="'+dzsap_settings.siteurl+'/wp-content/plugins/dzs-zoomsounds-portal/readme" target="_blank" aria-label="Documentation DZS Portal for ZoomSounds">Documentation</a></span> | ');
}

